/**
 * MISSPOCA 首頁互動 JS
 * 定案：2026-05-23（v17 mockup）
 * 設計系統 SSOT：vault 01_品牌核心/視覺識別系統/MISSPOCA 網頁設計系統.md
 *
 * 功能：
 * 1. Video section IntersectionObserver 滑入自動播放（透過 YouTube IFrame API）
 *    - 觸發條件：video 區 50% 進入視窗
 *    - 滑出：暫停
 *    - 預設 mute（瀏覽器 autoplay 政策）
 * 2. （未來擴增）mega menu 觸控裝置支援 / 商品 hover 預覽 / 滾動視差等
 */
(function() {
  // ===== 1. Video 滑入自動播放 =====
  // 等 YouTube IFrame API 載入後執行
  window.onYouTubeIframeAPIReady = function() {
    const iframe = document.getElementById('misspoca-yt-player');
    if (!iframe) return;

    const player = new YT.Player(iframe, {
      events: {
        'onReady': function() {
          // 偵測 video section 進入視窗 50% → play
          const videoSection = document.querySelector('.misspoca-video-section, [data-misspoca-video]');
          if (!videoSection) return;

          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                try { player.playVideo(); } catch (e) {}
              } else {
                try { player.pauseVideo(); } catch (e) {}
              }
            });
          }, { threshold: 0.5 });

          observer.observe(videoSection);
        }
      }
    });
  };

  // 動態載入 YouTube IFrame API（若頁面有 video player）
  if (document.querySelector('#misspoca-yt-player') && !window.YT) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }
})();


/* （2026-07-07 Oswin 指示：全站光斑效果已移除，含首頁） */

/* 不在購物車頁按任何「前往結帳」（加入購物車彈窗、快速購物車）→ 先帶到購物車頁填收件資料／送禮／優惠代碼（2026-10-14 V39）
   snippets/free-shipping-bar.liquid 也有同樣攔截，但購物車是空的時候那個區塊不會載入（實際訂單 #1003 就是這樣直接進結帳、地址沒預填）→ 這裡全站再攔一次 */
(function() {
  if (/^\/cart\/?$/.test(location.pathname)) return;
  var CHECKOUT_SEL = '[name="checkout"], a[href$="/checkout"], .purchase-confirmation-popup__submit';
  var toCart = function(e) {
    var t = e.target;
    var hit = e.type === 'click' ? (t && t.closest && t.closest(CHECKOUT_SEL)) : (t && t.querySelector && t.querySelector(CHECKOUT_SEL));
    if (!hit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    location.href = '/cart';
  };
  document.addEventListener('click', toCart, true);
  document.addEventListener('submit', toCart, true);
})();

/* 首購代碼＋贈品校正（2026-10-26 V50 起：初見之禮 2ml、代碼可合併；2026-10-28 V52：送禮賀卡改成客人自己加購、送禮才免費、訂單備註修正；2026-11-01 V63：回購送 2ml、聖誕贈品自動放；見 assets/misspoca-card-code-<CC_VER>.js）：全站載入
   ⚠️ 要改程式：另存新檔名 misspoca-card-code-<新號碼>.js，再把下面 CC_VER 改成新號碼（CDN 會快取舊檔，同檔名改內容不會更新） */
(function() {
  var CC_VER = '20261101a';
  var cs = document.currentScript;
  if (!cs || !cs.src) return;
  var s = document.createElement('script');
  s.src = cs.src.replace('misspoca-homepage.js', 'misspoca-card-code-' + CC_VER + '.js').replace(/\?.*$/, '');
  s.defer = true;
  document.head.appendChild(s);
})();
